import { customReports } from "../../constants/actionTypes";

const INITIAL_STATE = {
  filterListData: {},
  filterListError: {},
  customReportListData: {},
  customReportListAllData: {},
  customReportListError: {},
  loader: false,
};

const customReportsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case customReports.GET_CUSTOM_FILTER_REQUEST:
      return {
        ...state,
        loader: true,
      };
    case customReports.GET_CUSTOM_FILTER_SUCCESS:
      return {
        ...state,
        filterListData: action?.payload,
        loader: false,
      };
    case customReports.GET_CUSTOM_FILTER_FAILURE:
      return {
        ...state,
        filterListError: action?.payload,
        loader: false,
      };
    case customReports.GET_CUSTOM_REPORT_REQUEST:
      return {
        ...state,
        loader: true,
      };
    case customReports.GET_CUSTOM_REPORT_SUCCESS:
      return {
        ...state,
        customReportListData: action?.payload,
        loader: false,
      };
    case customReports.GET_CUSTOM_REPORT_RESET:
      return {
        ...state,
        customReportListData: INITIAL_STATE.customReportListData,
        customReportListAllData: INITIAL_STATE.customReportListAllData,
        loader: false,
      };
    case customReports.GET_CUSTOM_REPORT_REQUEST_ALL_DATA:
      return {
        ...state,
        loader: true,
      };
    case customReports.GET_CUSTOM_REPORT_ALL_DATA_SUCCESS:
      return {
        ...state,
        customReportListAllData: action?.payload,
        loader: false,
      };
    case customReports.GET_CUSTOM_REPORT_FAILURE:
      return {
        ...state,
        customReportListError: action?.payload,
        loader: false,
      };

    default:
      return state;
  }
};

export default customReportsReducer;
